import React from 'react';
import { List as MuiList } from '@material-ui/core';
import styles from './styles.module.scss';
function List({ children, emptyText = 'Ничего не найдено' }) {
    return (React.createElement(MuiList, null, children instanceof Array && (children === null || children === void 0 ? void 0 : children.length) === 0 ? (React.createElement("div", { className: styles.emptyText }, emptyText)) : (children)));
}
export default List;
